export const fetchData = async(route, options, asBlob = false) => {

    try {
        //NOTE ON API URLS:
            //url is pulled from either env.local, env.development, or env.production when app is built
            //see build scripts in package.json - these are referrenced in github workflow files
            //do this within app, rather than in azure environment variables, because env variables are injected when built, before app gets to azure app service

        const url = process.env.REACT_APP_API_URL

        // Ensure cookies are sent with requests (for httpOnly JWT cookie)
        options.credentials = 'include';

        let response;

        // Catch network errors (connection drop, empty response, net::ERR_EMPTY_RESPONSE, etc)
        try {
            response = await fetch(`${url}${route}`, options);
        } catch (networkError) {
            console.error('Network error in fetch:', networkError);
            return {
                success: false,
                error: networkError,
                errorType: 'NETWORK_ERROR',
                message: 'Connection failed - server did not respond. Please check your network connection or try again.',
                details: networkError.message
            };
        }

        // Check HTTP status code
        if (!response.ok) {
            console.warn(`HTTP error ${response.status}:`, response.statusText);
            
            // Try to extract server's error message from response body
            let serverMessage = null;
            try {
                const errorBody = await response.json();
                serverMessage = errorBody.message || errorBody.error || null;
            } catch (e) {
                // Failed to parse error response body, that's ok - will use fallback message
            }
            
            return {
                success: false,
                errorType: 'HTTP_ERROR',
                status: response.status,
                message: serverMessage || `Server returned status ${response.status}. Please try again later.`,
                statusText: response.statusText
            };
        }

        // Attempt to parse response body
        let data;
        try {
            if(asBlob){
                data = await response.blob();
            } else {
                data = await response.json();
            }
        } catch (parseError) {
            console.error('Error parsing response:', parseError);
            return {
                success: false,
                error: parseError,
                errorType: 'PARSE_ERROR',
                message: 'Server sent an invalid response. This may be a temporary issue. Please try again.',
                details: 'Failed to parse response data'
            };
        }

        return data;
    } catch (error) {
        // Catch-all for any other unexpected errors
        console.error('Unexpected error in fetchData:', error);
        return {
            success: false,
            error: error,
            errorType: 'UNKNOWN_ERROR',
            message: 'An unexpected error occurred. Please try again.',
            details: error.message
        };
    }
}